import React from 'react';
import { ZoovuStoryblok } from '../../../_shared/interfaces/storyblok';
import { StoryblokCommon } from '../../../lib/storyblok/storyblok';
import { trackEvent } from '../../../lib/track/track';

declare global {
    interface Window {
        hbspt: any;
    }
}

const Zoovu = ({ blok, storyblokCommon }: { blok: ZoovuStoryblok; storyblokCommon: StoryblokCommon }) => {
    if (storyblokCommon.configuration.content.theme === 'dr') {
        import('./zoovu.dr.scss').then();
    } else {
        import('./zoovu.hs.scss').then();
    }

    let trackDeeplink: string = '';
    const trackInteract = (e: Event): void => {
        const container = document.querySelectorAll('#zoovu-assistant > div');
        const classList = (e.target as HTMLElement)?.classList;
        const hasClickedElement = document.querySelectorAll('#zoovu-assistant .' + classList[0]);
        if (container.length > 0 && classList.length > 0 && hasClickedElement.length > 0) {
            const elem = document.getElementById('gatsby-focus-wrapper');
            elem?.removeEventListener('click', trackInteract, false);
            trackEvent('serviceassistant.open', {});
        }
    };

    const trackChooseService = (e: Event): void => {
        const className = (e.target as HTMLButtonElement)?.className;
        if (!!className && className.toString().includes('go-to-product-button') && trackDeeplink) {
            const params = new URLSearchParams(trackDeeplink);
            trackEvent('serviceassistant.sent', {
                product: {
                    id: params.get('p') ?? '',
                    manufacturer: params.get('m') ?? '',
                    service: params.get('s') ?? '',
                },
            });
        }
    };

    const trackGetDeeplink = (): void => {
        const elem = document.querySelector('a.go-to-product-button');
        const deepLink = elem?.getAttribute('href') as string;
        if (elem && !!deepLink) {
            trackDeeplink = decodeURIComponent(deepLink).split('?').pop() as string;
        }
    };

    React.useEffect(() => {
        if (typeof window !== 'undefined' && blok.script.url) {
            const script = document.createElement('script');
            script.src = blok.script.url;
            document.body.appendChild(script);

            const elem = document.getElementById('gatsby-focus-wrapper');
            elem?.addEventListener('click', trackInteract, false);
            elem?.addEventListener('click', trackChooseService, false);
            document.addEventListener('DOMSubtreeModified', trackGetDeeplink, false);
            return () => {
                elem?.removeEventListener('click', trackInteract, false);
                elem?.removeEventListener('click', trackChooseService, false);
                document.removeEventListener('DOMSubtreeModified', trackGetDeeplink, false);
            };
        }
    }, []);

    return (
        <div>
            <div id={blok.id}>
                <p>{blok.loading}</p>
            </div>
        </div>
    );
};

export default Zoovu;
